import { Spin } from "antd";
import * as React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { ILegalViewTypesPresenter } from "../../presenter/LegalViewTypesPresenter";
import LegalViewTypeGrid from "../components/LegalViewTypeGrid";

export interface Props extends PageProps {}
export interface State extends ILegalViewTypesPresenter {}

export default class LegalViewTypesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      legalViewTypes,
      createLegalViewType,
      updateLegalViewType
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.legalViewTypeLoader}>
            <LegalViewTypeGrid
              translate={translate}
              legalViewTypes={legalViewTypes}
              createLegalViewType={createLegalViewType}
              referenceLoader={this.state.loaders.legalViewTypeLoader}
              updateLegalViewType={updateLegalViewType}
            />
          </Spin>
        }
      </Page>
    );
  }
}
